export default __webpack_public_path__ + "static/media/suffixWorkImg.2de7360a.png";